export const UPDATE_SEARCH_VALUE = 'header.UPDATE_SEARCH_VALUE';
export const UPDATE_ACTIVE_TAB = 'header.UPDATE_ACTIVE_TAB';
export const SIDEBAR_OPEN = 'header.SIDEBAR_OPEN';
export const SIDEBAR_CLOSE = 'header.SIDEBAR_CLOSE';
